import React from "react";
import ProductsBanner from "./components/productsBanner";
import { useNavigate } from "react-router-dom";
import MetaTagsSEO from "../../utils/metaTagsFunction";

function ProductsPage() {
  const navigate = useNavigate();

  return (
    <>
      <MetaTagsSEO metaTags={[]} title="Products - JBGlass" />

      <ProductsBanner />

      <section className="productMainWrapper py-100">
        <div className="container">
          <div className="row iconTxtMain">
            <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-4">
              <div className="iconTxtHldr">
                <div className="iconMain">
                  <img src="/assets/images/prod-icon1.webp" alt="" />
                </div>
                <div className="iconconta">
                  <b>Site Survey</b> ensures perfect fit and flawless execution.
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-4">
              <div className="iconTxtHldr">
                <div className="iconMain">
                  <img src="/assets/images/prod-icon2.webp" alt="" />
                </div>
                <div className="iconconta">
                  <b>Design Consultation</b> helps us understand your vision for
                  tailor made solutions.
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-4">
              <div className="iconTxtHldr">
                <div className="iconMain">
                  <img src="/assets/images/prod-icon3.webp" alt="" />
                </div>
                <div className="iconconta">
                  <b>Timely Delivery</b> brings innovation directly to your
                  doorstep.
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-6 mb-4">
              <div className="iconTxtHldr">
                <div className="iconMain">
                  <img src="/assets/images/prod-icon4.webp" alt="" />
                </div>
                <div className="iconconta">
                  <b>Expert Installation</b> ensures a seamless and efficient
                  on-site process.
                </div>
              </div>
            </div>
          </div>

          <div className="row productImgHldr mt-4">
            <div className="col-lg-3 col-md-3 col-sm-6 col-12 mb-4">
              <div className="proImgMain">
                <img src="assets/images/prod-img1.webp" alt="" />
              </div>
              <div
                className="ImgProdBoxHldr"
                onClick={() => navigate("/product/waltz/slide-nxt?id=slidNxt")}
              >
                <div className="prodIconHldr">
                  <img src="assets/images/slide-icon.webp" alt="" />
                </div>
                <h2>WALTZ SLIDE NXT</h2>
                <p>
                  Slim structural profiles of WALTZ SLIDE NXT door and partition
                  systems allows more efficient space utilization, creates a
                  sense of openness in interior spaces and provides significant
                  energy cost savings.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-12 mb-4">
              <div className="proImgMain">
                <img src="assets/images/prod-img2.webp" alt="" />
              </div>
              <div
                className="ImgProdBoxHldr"
                onClick={() => navigate("/product/waltz/glide-nxt?id=glideNxt")}
              >
                <div className="prodIconHldr">
                  <img src="assets/images/glide-icon.webp" alt="" />
                </div>
                <h2>WALTZ GLIDE NXT</h2>
                <p>
                  Majestic high doors rotating effortlessly on precision
                  engineered pivot, the clean lines and endless styles of WALTZ
                  GLIDE NXT ooze style, modernity and elegance.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-12 mb-4">
              <div className="proImgMain">
                <img src="assets/images/prod-img3.webp" alt="" />
              </div>
              <div
                className="ImgProdBoxHldr"
                onClick={() => navigate("/product/waltz/swing-nxt?id=swingNxt")}
              >
                <div className="prodIconHldr">
                  <img src="assets/images/swing-icon.webp" alt="" />
                </div>
                <h2>WALTZ SWING</h2>
                <p>
                  Make a grand entrance with WALTZ SWING. Spectacularly sleek in
                  design with next to effortless motion, its superior
                  engineering makes it easy to install with an immaculate
                  finish.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 col-12 mb-4">
              <div className="proImgMain">
                <img src="assets/images/prod-img4.webp" alt="" />
              </div>
              <div
                className="ImgProdBoxHldr"
                onClick={() => navigate("/product/waltz/close-nxt?id=closeNxt")}
              >
                <div className="prodIconHldr">
                  <img src="assets/images/shape-icon.webp" alt="" />
                </div>
                <h2>WALTZ CLOSE NXT</h2>
                <p>
                  WALTZ CLOSE NXT brings the aesthetics and functional
                  superiority of WALTZ SWING and WALTZ SLIDE NXT to modern
                  bathrooms, with a highly functional splash proof mechanism.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductsPage;
